import _ from 'lodash'

import { TEXT_POSITION } from './constants'

export const getTextPositions = (textArray) => {
    const texts = _.map(textArray, (text) => ({
        ...text,
        position: text.count > 0 ? TEXT_POSITION.CENTER : null,
    }))

    const startIndex = _.findIndex(texts, (text) => text.position === TEXT_POSITION.CENTER)
    const endIndex = _.findLastIndex(texts, (text) => text.position === TEXT_POSITION.CENTER)

    texts[startIndex].position = TEXT_POSITION.START
    if (startIndex !== endIndex) texts[endIndex].position = TEXT_POSITION.END

    return texts
}
